<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />

        <div class="container-fluid">
            <div class="row">

                <div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3" v-for="(card, ci) in cardsInfo" :key="ci">
                            <div class="mt-1 p-0 mb-2 shadow-v2" style="border-radius: 5px 5px 90px 5px;">
                                <div class="row g-0 box-info">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-11 pt-3 ps-4">
                                                <p class="card-text mb-1">
                                                    <span class="cart-title-span" style="font-size: 14px;">
                                                        {{ card.nmDado }}
                                                    </span>
                                                </p>                                            
                                                <p class="card-text pt-1">
                                                    <span class="cart-title-span"
                                                          style="font-weight: bold; font-size: 18px; color: #9F3029;">
                                                        {{ card.vlDado }}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>
</template>

<script>

    import axios from 'axios';
    import OcorrenciaInfo from '../../../../components/Tickets/Ocorrencia/Ocorrencia_Info.vue'

    export default {
        name: 'Usabilidade',
        components: {
            OcorrenciaInfo
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                ocorrencia: {},
                cardsInfo: [],
            }
        },
        updated() { },
        methods: {
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.GetUsabilidade();
                })
            },
            GetUsabilidade() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModuloDadoValor/Usabilidades?idOcorrencia=' + $this.idOcorrencia, {
                    headers: this.$api.getTokenComercial(),             
                }).then(response => {
                    $this.cardsInfo = response.data.data;                 
                });
            },

        },
        mounted() {
            this.getOcorrencia();
        },
        watch: {
            idOcorrencia(newVal, oldVal) {
                this.getOcorrencia();
            },
        },
    }

</script>

<style scoped lang="scss">

    .cart-title-span {
        font-weight: bold;
        margin-left: 5px;
    }

    .box-info {
        min-height: 100px;
        font-size: 14px;
    }

    </style>